export default __webpack_public_path__ + "static/video_processing_ru-ce1f16623553f8c4e1b9e5e724bc712d.png";